import { useQueries } from '@tanstack/react-query'
import { getAvailableClassesByTeacher } from 'api/classroom/classroom'

import { getHomeData } from 'api/home'
import { CLASSROOM_KEYS } from 'hooks/classroom'

export const KEY_HOME = 'HOME'

export const useParallelHomeData = ({ id }) => {
  return useQueries({
    queries: [
      { queryFn: getHomeData, queryKey: [KEY_HOME], staleTime: Infinity },
      {
        queryFn: ({ signal }) =>
          getAvailableClassesByTeacher({ signal, teacherId: id }),
        queryKey: [CLASSROOM_KEYS.AVAILABLE_CLASSES, id],
        staleTime: Infinity,
      },
    ],
  })
}
